import styled, { css } from "styled-components";
import { NavLink } from "react-router-dom";

import { containerOnHover } from "../../commonStyles";

export const StyledLabel = styled.span<{ $isCollapsed: boolean }>`
  display: ${({ $isCollapsed }) => ($isCollapsed ? "none" : "block")};
  text-transform: uppercase;
  ${({ theme }) => theme.typography.body2};
  color: ${({ theme }) => theme.colors.fg.primary};
  line-height: 16px;
  margin-left: 16px;
  flex: 1;
`;

export const Container = styled.div`
  margin-top: 8px;
  align-items: center;
  box-sizing: border-box;
  ${({ theme }) => theme.typography.menuText}
  color: ${({ theme }) => theme.colors.txt.value};
  text-decoration: none;
  cursor: pointer;
`;

export const StyledNavLink = styled(NavLink)`
  margin-top: 8px;
  display: block;
  align-items: center;
  box-sizing: border-box;
  ${({ theme }) => theme.typography.menuText}
  color: ${({ theme }) => theme.colors.txt.value}!important;
  text-decoration: none !important;
  cursor: pointer;
  ${containerOnHover};

  /* The label sets its own colour, so the accent has to be applied to it
     directly — inheriting from the link is not enough. */
  &:hover,
  &.active {
    ${StyledLabel} {
      color: ${({ theme }) => theme.colors.fg.accent};
    }
  }
`;

export const StyledNavSubLink = styled(NavLink)`
  margin-top: 8px;
  display: block;
  align-items: center;
  box-sizing: border-box;
  ${({ theme }) => theme.typography.menuText}
  color: ${({ theme }) => theme.colors.txt.label2};
  text-decoration: none !important;
  cursor: pointer;

  &:hover,
  &.active {
    color: ${({ theme }) => theme.colors.fg.accent};
  }

  &.active {
    border-bottom: 1px solid ${({ theme }) => theme.colors.fg.accent};
  }
`;

export const StyledNavLinkRowDropdown = styled.div<{
  $isActive: boolean;
  $isHover: boolean;
}>`
  position: relative;
  display: flex;
  align-items: center;
  padding: 12px;

  border-radius: 8px;

  ${containerOnHover};
  /* Expanding the dropdown must not mark the parent selected — only a matching
     child route does. */
  background: ${({ theme, $isActive, $isHover }) =>
    $isActive || $isHover ? theme.colors.fg.accent12 : "inherit"};

  /* This row is a div, so containerOnHover's &.active can never match it. CRM
     still swaps in the selected artwork whenever a child route is active. */
  ${({ theme, $isActive }) =>
    $isActive &&
    css`
      .nav-icon i,
      .nav-icon svg {
        color: ${theme.colors.fg.navIconActive};
      }
    `}

  &:hover ${StyledLabel} {
    color: ${({ theme }) => theme.colors.fg.accent};
  }

  ${({ theme, $isActive, $isHover }) =>
    ($isActive || $isHover) &&
    css`
      ${StyledLabel} {
        color: ${theme.colors.fg.accent};
      }
    `}
`;

export const StyledNavLinkRow = styled.div<{ $isSubItem: boolean }>`
  position: relative;
  display: flex;
  align-items: center;
  padding: 12px;
  border-radius: 8px;
  padding-left: ${({ $isSubItem }) => ($isSubItem ? 0 : "12px")};
`;

export const StyledDropdown = styled.div`
  span {
    text-transform: none;
  }
`;

export const NavIcon = styled.span`
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
`;

export const StyledDropdownIcon = styled.i<{ $isCollapsed: boolean }>`
  font-size: 24px;
  color: ${({ theme }) => theme.colors.fg.tertiary};

  ${({ $isCollapsed }) =>
    $isCollapsed &&
    `
    font-size: 12px;
  `}
`;
